<template>
  <div>
    <Tab
      v-for="(tab, index) in tabs"
      :title="tab.title"
      :index="index"
      :subTitle="tab.subTitle"
      :key="tab.id"
      :isSelected="tab.isSelected"
      :disabled="disableAll || tab.disabled"
      @getSelected="getSelected"
    ></Tab>
  </div>
</template>

<script>
import Tab from './Tab';
export default {
  components: {
    Tab
  },
  props: {
    multiSelect: {
      default: false
    },
    tabs: {
      default: []
    },
    disableAll: {
      default: false
    }
  },
  methods: {
    getSelected(data) {
      this.$emit('getSelected', data);
    }
  }
};
</script>
